/**
* @Author: Michael Neumair <mBook>
* @Date:   2016-09-27T10:46:06+02:00
* @Email:  7q7w7e7r@gmail.com
* @Last modified by:   mBook
* @Last modified time: 2016-10-10T10:07:12+02:00
*/


import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {actions} from 'react-redux-form/src';
import {Control, Errors} from 'react-redux-form/src';
import AErrorInput from './../components/AErrorInput';
import MErrorGroupInput from './../components/MErrorGroupInput';
import AInputCheckbox from './../components/AInputCheckbox';
import shouldShowErrors from './shouldShowErrors';

// FIXME: This is a temp fix for issue:
// https://github.com/davidkpiano/react-redux-form/issues/454
function mapDispatchToProps(dispatch, ownProps) {
  return {
    onPress: (event) => {
      if (ownProps.onPress) {
        ownProps.onPress(event);
      }
      if (ownProps.validators) {
        setTimeout(() => {
          dispatch(actions.validate(ownProps.model, ownProps.validators));
        }, 0); // on next tick
      }
    },
  };
}


/**
 * OInputFieldCheckbox - …
**/
class OInputFieldCheckbox extends Component {
  render() {
    const {
      model,
      children,
      defaultValue,
      disabled,
      validators,
      validateOn,
      asyncValidators,
      messages,
      showErrors,
      onPress, // just a fix, see above
    } = this.props;

    return (
      <div className="o-input-field o-input-field-checkbox" onClick={onPress}>
        <Control.checkbox
          model={model}
          component={AInputCheckbox}
          defaultValue={defaultValue}
          validators={validators}
          validateOn={validateOn}
          asyncValidators={asyncValidators}
          controlProps={{
            id: model,
            disabled,
            children,
          }}
          mapProps={{
            error: (props) => {
              shouldShowErrors(showErrors, props)},
          }}
        />
        <Errors
          model={model}
          messages={messages}
          wrapper={MErrorGroupInput}
          component={AErrorInput}
          show={showErrors}
        />
      </div>
    );
  }
}
OInputFieldCheckbox.propTypes = {
  /**
     * react-redux-form model
     * see: https://davidkpiano.github.io/react-redux-form/docs/guides/models.html
     */
  model: PropTypes.string.isRequired,
  /**
     * elements displayed beside the checkbox - do not use inputs there!
     */
  children: PropTypes.any,
  /**
     * default value of the component
     */
  defaultValue: PropTypes.bool,
  /**
     * disable the input
     */
  disabled: PropTypes.bool,
  /**
     * hash with validator functions
     * see: https://davidkpiano.github.io/react-redux-form/docs/guides/validation.html
     */
  validators: PropTypes.object,
  /**
     * when validation should be fired
     * see: https://davidkpiano.github.io/react-redux-form/docs/guides/validation.html
     */
  validateOn: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array,
  ]),
  /**
     * hash with async validator functions
     * see: https://davidkpiano.github.io/react-redux-form/docs/guides/validation.html
     */
  asyncValidators: PropTypes.object,
  /**
     * error messages for validatiors
     * see: https://davidkpiano.github.io/react-redux-form/docs/guides/validation.html
     */
  messages: PropTypes.object,
  /**
     * when errors should be shown
     * function which gets passed the props of the form-model
     * see: https://davidkpiano.github.io/react-redux-form/docs/api/Errors.html#show
     */
  showErrors: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.bool,
  ]).isRequired,
};
OInputFieldCheckbox.defaultProps = {
  validateOn: ['focus', 'change', 'blur'],
};
export default connect(null, mapDispatchToProps)(OInputFieldCheckbox);
